<template>
	<div class="result-upper-row">
    <div class="container">
      <div class="row align-items-start flex-column-reverse flex-sm-row">
        <div class="col-sm-12 col-lg-6 col-md-7">
          <div class="backbutton-container">
            <a v-if="goalType == 'HEALTH' || goalType == 'EDU'" href="/#goals" class="btn-textlinkLeftIcon"><span><i class="ph-arrow-left-bold"></i></span>back</a>
            <a v-if="goalType == 'MRG' || goalType == 'VAC' || goalType == 'CAR' || goalType == 'startup'" href="/goals-custom" class="btn-textlinkLeftIcon"><span><i class="ph-arrow-left-bold"></i></span>back</a>
          </div>
          <div class="investment-container">
            <h2 class="hf_heading02">What you need to know about your investment</h2>
            <!-- CALCULATOR SECTION -->
            <div class="calc-outer-container calculator-box">
              <div class="goals-calc-container">
                <div class="goals-calculator-box">
                  <div class="calculator">
                    <!-- calculator section for health goal -->
                    <form action="showHlthResult" method="post" id="showHlthResult">
                    	<input type="hidden" v-model="_token" name="_token">
			  							<div class="form-group dynamic-input">
			  								<span class="plane-text">I need {{ (goalTypePass == "EDU" ? 'an' : 'a')}} {{ goalTopTextPass }} corpus </span>
			  							
			  								<label>of<span class="inr-symbol hf_dark">&#8377;</span></label>
			  								<input type="text" id="amount" name="amountReqd" v-model="amountReqdPass" class="restDot numbersonly" :class="amountReqdMClass" @keyup="resetCalculation()" placeholder="5,00,000" min="0" maxlength="14" required>
			  								<span class="plane-text">in</span>
												<input type="number" id="year" name="yearReqd" v-model="yearReqdPass" class="restDot numbersonly width-dynamic" :class="yearReqdMClass" @keyup="resetCalculation()" placeholder="5" min="0" maxlength="2" @input="updateYearVal()" required>
												<span class="plane-text">years</span>
                        {{ (goalType == "MRG" || goalType == "startup" || goalType == "VAC" || goalType == "CAR" ? "" : ".") }}
			  							</div>

                      <div v-if="goalType == 'MRG'" class="form-group dynamic-input">
                        <span class="plane-text">for my child’s wedding/ my wedding.</span>
                      </div>
                      <div v-if="goalType == 'startup'" class="form-group dynamic-input">
                        <span class="plane-text">for my start-up.</span>
                      </div>
                      <div v-if="goalType == 'VAC'" class="form-group dynamic-input">
                        <span class="plane-text">for my vacation.</span>
                      </div>
                      <div v-if="goalType == 'CAR'" class="form-group dynamic-input">
                        <span class="plane-text">for my dream car.</span>
                      </div>
			  							<div class="notification-message">
                        <p v-show="showError" class="errorMessage inflation-text hf_bodytext02">
                          <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
  			            			{{ showErrorText }}
  			          			</p>
                      </div>
                      <div class="recalculate-button-container">
                        <a href="javascript:void(0)" type="button" class="btn-textlinkLeftIcon lg-textlinkleftIcon" ref="myBtn" @click.stop="showResult(0)"><span class="ph-arrow-clockwise-bold"></span>Recalculate</a>
                      </div>
			  						</form>
                    <!-- end calculator section for education goal -->
                  </div>
                </div>
              </div>
            </div>
            <!-- END CALCULATOR SECTION -->
            <!-- CALCULATIONS RESULT SECTION -->
            <div class="calc-result-container">
              <!-- health goal result -->
              <p class="hf_bodytext01 goalHealth">Considering inflation of <span class="calculation-number">{{ inflation }}</span>%, you would need {{ (goalType == "EDU" ? 'an' : 'a')}} {{ goalText }} corpus of <span class="inr-symbol hf_dark">&#8377;</span><span class="calculation-number">{{ fvResultHtml }}</span> in <span class="calculation-number">{{ accmpYear }}</span>.</p>
              <!-- end health goal result -->
            </div>
            <!-- END CALCULATIONS RESULT SECTION -->

            <!-- RANGE SLIDER ONLY FOR CAR LOAN -->
            <div class="carloan-section goalCar" v-if="goalType == 'CAR'">
                <h4 class="hf_heading06">How would you like to fund your goal? </h4>
                <div class="main">
                  <input type="range" min="0" max="90" id="slider" step="1" v-model="loanPercent" ref="loanSlideRef" width="100%">
                  <div id="selector">
                    <div class="selectBtn"></div>
                    <div id="selectValue"></div>
                  </div>
                  <div id="progressBar"></div>
                  <div id="left-value">
                    <p class="hf_subheading">LOAN</p>
                    <h4 class="before-value"><span class="inr-symbol hf_dark">&#8377;</span>{{ recommendedLoanHtml }}</h4>
                  </div>
                  <div id="right-value">
                    <p class="hf_subheading">SELF CONTRIBUTION</p>
                    <h4 class="after-value"><span class="inr-symbol hf_dark">&#8377;</span>{{ selfContributionHtml }}</h4>
                  </div>
                </div>
                <div class="loan-require-container">
                  <p class="hf_heading06">I need to plan for <span class="inr-symbol hf_dark">&#8377;</span>{{ selfContributionHtml }}</p>
                </div>
              </div>
            <!-- END RANGE SLIDER ONLY FOR CAR LOAN -->

            <!-- INVESTMENT SECTION -->
            <div class="current-invest-box">
              <div class="sip-container nonWealthGoal">
                <div class="education-box">
                  <p class="hf_bodytext02">You need to invest</p>
                  <h4 class="amount-txt"><span class="rupee-symbol">&#8377;</span><span>{{ recomdSIPHtml }}</span></h4>
                  <p class="hf_bodytext02">Per month</p>
                  <p class="hf_bodytext02 minHeight no-margin">for <span>{{ noOfYear }}</span> years to achieve your goal.</p>
                </div>
              </div>
              <div class="seperater-box nonWealthGoal">
                <p class="hf_subheading">OR</p>
              </div>
              <div class="lumpsum-container nonWealthGoal">
                <div class="education-box">
                  <p class="hf_bodytext02">You need to invest</p>
                  <h4 class="amount-txt"><span class="rupee-symbol">&#8377;</span><span>{{ recomdLumpsumHtml }}</span></h4>
                  <p class="hf_bodytext02">One time</p>
                  <p class="hf_bodytext02 minHeight no-margin">to achieve your goal.</p>
                </div>
              </div>
            </div>
            <!-- END INVESTMENT SECTION -->
          </div>
        </div>
        <!-- GOAL IMAGES SECTION -->
        <div class="col-sm-12 col-lg-6 col-md-5">
          <div class="goal-image-box">
            <img v-if="goalType == 'HEALTH'" fetchpriority="high" src="img/goal-health.webp" class="goalHealth" alt="">
            <img v-if="goalType == 'EDU'" fetchpriority="high" src="img/goal-education.webp" class="goalEducation" alt="">
            <img v-if="goalType == 'MRG'" fetchpriority="high" src="img/goal-wedding.webp" class="goalEducation" alt="">
            <img v-if="goalType == 'VAC'" fetchpriority="high" src="img/goal-vacation.webp" class="goalEducation" alt="">
            <img v-if="goalType == 'startup'" fetchpriority="high" src="img/goal-startup.webp" class="goalEducation" alt="">
            <img v-if="goalType == 'CAR'" fetchpriority="high" src="img/goal-car.webp" class="goalEducation" alt="">
          </div>
        </div>
        <!-- END GOAL IMAGES SECTION -->
      </div>
    </div>
  </div>
  <div class="result-lower-container nonWealthGoal">
    <div class="container">
      <div class="row d-flex flex-sm-row-reverse">
        <!-- INSIGHT SECTION -->
        <div class="col-sm-12 col-lg-6 col-md-5">
          <div class="insight-container">
            <p class="hf_subheading">Valuable insights for you</p>
              <!-- insights for health goal -->
              <ul v-if="goalType == 'HEALTH'" class="insight-list goalHealth">
                <li>Health insurance doesn’t cover certain expenses, like voluntary tests, pre-existing illnesses, and external healthcare equipment. It is prudent to set aside a health corpus so you don’t compromise your financial wellbeing, especially post-retirement.</li>
                <li>Many retirees tend to discontinue their health insurance after a certain point of time thinking of it as a waste of money. However, when they face unexpected healthcare needs, they regret the decision.</li>
              </ul>
              <!-- end insights for health goal -->

              <!-- insights for education goal -->
              <ul v-if="goalType == 'EDU'" class="insight-list goalEducation">
                <li>The cost of higher education is rising at 10-12% a year globally.</li>
                <li>If you don't plan early, you would end up compromising your financial well-being to pay for your child's education expenses and you might not even be able to send them to the desired institution.</li>
              </ul>
              <!-- end insights for education goal -->

              <!-- insights for wedding goal -->
              <ul v-if="goalType == 'MRG'" class="insight-list goalWedding">
                <li>By planning for your child’s wedding, you can make their dream destination wedding come true without being financially worried.</li>
                <li>People tend to withdraw money from their PPF/EPF account for their child’s wedding. So, plan for it now to rid yourself of last-minute financial stress.</li>
              </ul>
              <!-- end insights for wedding goal -->

              <!-- insights for startup goal -->
              <ul v-if="goalType == 'startup'" class="insight-list goalStartup">
                <li>Building a corpus for your start-up allows you to focus on it without worrying about family responsibilities, especially in the first few years.</li>
                <li>Start-up planning requires you to set aside a corpus equivalent to 5 years of house running needs.</li>
              </ul>
              <!-- end insights for startup goal -->

              <!-- insights for vacation goal -->
              <ul v-if="goalType == 'VAC'" class="insight-list goalVacation">
                <li>A vacation corpus allows you to take a break from your everyday life and destress without any guilt. </li>
                <li>By planning ahead for a vacation, you can upgrade to your dream destination, from Manali to Paris.</li>
              </ul>
              <!-- end insights for vacation goal -->

              <!-- insights for car goal -->
              <ul v-if="goalType == 'CAR'" class="insight-list goalCar">
                <li>By planning for your car now, you can upgrade your lifestyle easily, from a hatchback to an SUV.</li>
                <li>Building a car corpus will enable you to pay a higher down payment, thereby reducing the burden of EMIs.</li>
              </ul>
              <!-- end insights for car goal -->
          </div>
        </div>
        <!-- END INSIGHT SECTION -->
        
        <!-- COST OF DELAY SECTION -->
        <div class="col-sm-12 col-lg-6 col-md-7">
          <div class="delay-calculator-container">
            <p class="hf_subheading">Cost of delay</p>
            <!-- calculator section -->
  					<div class="goals-calculator-box">
              <div class="calculator">
    						<form action="#" role="form">
    							<div class="form-group">
                    <div class="goals-rangeSlider">
              				<div class="range-slider">
                        <p class="tip"><span>{{ value }}</span>year delay</p>
              					<input id="range" type="range" min="0" :max="csdnoOfYear" step="1" v-model="value" @change="updateSlider">
              				</div>
              			</div>
    							</div>
    						</form>
                <div class="notification-message">
      						<p v-show="csdshowError" class="errorMessage inflation-text hf_bodytext02">
                    <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
                    {{ showErrorText }}
                  </p>
                </div>
                <div class="inflation-box" v-show="showAmtDiff">
                  <p class="hf_bodytext02">If you delay by <span>{{ value }}</span> {{ (value > 1 ? 'years' : 'year') }}, you would need to increase your monthly amount by</p>
                  <h4 class="inflation-text hf_dark"><span class="rupee-symbol">&#8377;</span>{{ csdMonthlyDiffHtml }}</h4>
                  <br/>
                  <p class="hf_bodytext02">or else you would miss your target by</p>
                  <h4 class="inflation-text hf_dark"><span class="rupee-symbol">&#8377;</span>{{ csdtargetDiffHtml }}</h4>
                </div>
    					</div>
            </div>
  					<!-- end calculator section -->
          </div>
        </div>
        <!-- END COST OF DELAY SECTION -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {},
  data() {
    return {
    	_token : this.$token,
    	// goalType: 'HEALTH',
    	inflation: '',
    	accmpYear: '',
      fvResult: '',
    	netCorpForCalc: '',
    	fvResultHtml: '',
      amountReqdMClass: '',
      yearReqdMClass: '',
      mandatoryClassName: 'redunderline',
    	showErrorText: '',
    	showError: false,
    	showAmtDiff: false,
    	recomdSIP: '',
      recomdSIPHtml: '',
      recomdLumpsum: '',
      recomdLumpsumHtml: '',
      recommendedLoan: '',
      selfContribution: '',
      recommendedLoanHtml: '',
      selfContributionHtml: '',

      //parameters for cost of delay
      csdnoOfYear: '',
      csdrecomdSIP: '',
      csdrecomdLumpsum: '',
      csdMonthlyDiffHtml: '',
      csdtargetDiffHtml: '',
      csdshowError: false,
      goalTopTextPass: '',
      goalTextPass: '',
      goalTypePass: '',
      yearReqdPass: '',
      amountReqdPass: '',

      value: 0,
      loanPercent: 0,
      // backgroundSize: '20% 100%',
    };
  },
  props: {
    goalTopText: { type:String, default:''},
    goalText: { type:String, default:''},
    goalType: { type:String, default:'OTHR'},
  	yearReqd: { type:String, default:''},
  	amountReqd: { type:String, default:''},
  },
  mounted(){
  	// console.log("mounted event triggered");
    // console.log("goalTopText="+this.goalTopText);
    // console.log("goalText="+this.goalText);
    // console.log("goalType="+this.goalType);
    this.goalTopTextPass = this.goalTopText;
    this.goalTextPass = this.goalText;
    this.goalTypePass = this.goalType;
    this.yearReqdPass = this.yearReqd;
    this.amountReqdPass = this.amountReqd;

  	let temp = this.$refs.myBtn;
  	setTimeout(function() {
      temp.click();
    }, 1000);
  },
  watch: {
	  amountReqdPass(){
      var res =  this.formatAmount(this.amountReqdPass)
      this.amountReqdPass = res;
    },
  },
  methods: {
    updateYearVal: function(){
      var element = event.target;
      var maxlength = element.getAttribute('maxlength');
      if(this.yearReqdPass.toString().length > maxlength){
        let number = this.yearReqdPass;
        this.yearReqdPass = number.toString().substring(0, number.toString().length - 1);
      }
    },
  	updateSlider(e) {
      let clickedElement = e.target;
      let min = clickedElement.min;
      let max = clickedElement.max;
      let val = clickedElement.value;
      // this.backgroundSize = (val - min) * 100 / (max - min) + '% 100%';
      // console.log(clickedElement);
      // console.log("Slider val = "+val);
      // this.showResult(1);

      if(this.amountReqdPass == "" || this.amountReqdPass == undefined || this.yearReqdPass == "" || this.yearReqdPass == undefined){
        this.showAmtDiff = false;
      }else{
        if(this.value > 0){
          this.showCostDelay();

          var goalTypeApi2 = this.goalType;
          if(this.goalType == "startup"){
            goalTypeApi2 = "OTHR";
          }
          let goalAccYearApiTemp2 = this.accmpYear - this.value;
          this.showMontlyLumpsum(goalAccYearApiTemp2, 1, goalTypeApi2);
        }else{
          this.showErrorText = "";
          this.csdshowError = false;
          this.showError = false;
          this.showAmtDiff = false;
        }
      }
    },  
    showResult(){
  		// console.log("Click event triggered");

  		//Check for validation and collect data for calculations
  		//======================================================
      var self = this;
  		let amountReqd = this.amountReqdPass;
      amountReqd = String(amountReqd).replace(new RegExp(',', 'g'), '');
  		let yearReqd = this.yearReqdPass;

  		// When recalculate is press slider set to 0 again
      //================================================
      this.value = 0;
      this.showAmtDiff = false;
      if(this.goalType == "CAR"){
        this.loanPercent = 0;
        let loanslider = this.$refs.loanSlideRef;
        document.getElementById("progressBar").style.width = "0%";
        document.getElementById("selector").style.width = "0%";
        document.getElementById("selector").style.left = "-2%";
        // loanslider.change();
      }

  		if(amountReqd == "" || amountReqd == undefined || yearReqd == "" || yearReqd == undefined){
  			this.showErrorText = "Please enter mandatory data first";
  			this.showError = true;

        // Check for mandatory fields
        //==============================
        if(amountReqd == "" || amountReqd == undefined){
          this.amountReqdMClass = this.mandatoryClassName;
        }else{
          this.amountReqdMClass = "";
        }

        if(yearReqd == "" || yearReqd == undefined){
          this.yearReqdMClass = this.mandatoryClassName;
        }else{
          this.yearReqdMClass = "";
        }

  		}else{
        //remove all redunderline class for mandatory
        //============================================
        this.amountReqdMClass = "";
        this.yearReqdMClass = "";

  			//Check all the basic validations eg.age, amt
				//=============================================
        
        //check for goal type
        var goalTypeApi = this.goalType;
        if(this.goalType == "startup"){
          goalTypeApi = "OTHR";
        }
				axios.post('/chkOtherGoalValidations',{goalType: goalTypeApi, amountReqd: amountReqd, yearReqd: yearReqd, calcReq: 1, _token: this.$token})
        .then((response)=>{
        	// console.log(response);
        	let resData = response.data;
        	if(resData.status == true){
						this.showErrorText = "";
			    	this.showError = false;
        		
        		let inflrateData = resData.inflrate; 
			    	let inflrate = inflrateData['inflrate'];
			  		let goalLoanTenure = inflrateData['goalLoanTenure'];
			  		let goalLoanRoi = inflrateData['goalLoanRoi'];

            this.noOfYear = yearReqd;
            this.csdnoOfYear = yearReqd - 1;

			  		//================================================
            // Calculate Future value FV
            //================================================            
	  				this.fvResult = Math.round(this.calculateFV(inflrate, yearReqd, '0', amountReqd));
            this.netCorpForCalc = this.fvResult;
						// console.log("inflrate = "+inflrate);
						// console.log("yearReqd = "+yearReqd);
						// console.log("amountReqd = "+amountReqd);
						// console.log("fvResult = "+this.fvResult);

						this.accmpYear = (parseInt(new Date().getFullYear()) + parseInt(yearReqd));
						this.inflation = Math.round(inflrate*100);
			    	// console.log("accmpYear = "+this.accmpYear);
			    	// console.log("inflation = "+this.inflation);

			    	// show fv result
            // =============================================================
            this.fvResultHtml = this.shorthandCurrency(Math.round(this.fvResult), true);
            // console.log("fvResultHtml = "+this.fvResultHtml);
            //====================================

            //==================================================
            // Loan range slider code for initializing range slider
            //==================================================
            if(this.goalType == "CAR"){
              this.recommendedLoanHtml = this.shorthandCurrency(Math.round(0), true);
              this.selfContributionHtml = this.fvResultHtml;

              let slider = document.getElementById('slider')
              let selector = document.getElementById('selector')
              let selectValue = document.getElementById('selectValue')
              let progressBar = document.getElementById('progressBar')
              selectValue.innerHTML = slider.value;

              var fvResultSlider = this.fvResult;
              var recommendedLoanSlider = this.recommendedLoan;
              var selfContributionSlider = this.selfContribution;

              //On loan slider change 
              //=========================================
              slider.onchange = function() {
                selectValue.innerHTML = this.value
                selector.style.left = this.value + '%';
                progressBar.style.width = parseInt(this.value)+parseInt(2) + '%';

                // console.log("fvResult = "+fvResultSlider);
                // console.log("Loan require = "+this.value);
                recommendedLoanSlider = Math.round((fvResultSlider * this.value)/100);
                selfContributionSlider = Math.round(fvResultSlider - recommendedLoanSlider);

                self.recommendedLoanHtml = self.shorthandCurrency(recommendedLoanSlider, true);
                self.selfContributionHtml = self.shorthandCurrency(selfContributionSlider, true);
                // console.log(recommendedLoanSlider+"=>"+selfContributionSlider);

                //set netcorpus for calculation
                //======================================
                self.netCorpForCalc = selfContributionSlider;

                //Reset cost of delay slider
                //=================================
                self.value = 0;          
                self.showAmtDiff = false;       

                  let goalAccYearApiTemp = self.accmpYear;
                  self.showMontlyLumpsum(goalAccYearApiTemp, 0, goalTypeApi);
              }
            }
            //==================================================

            //================================================
            // Calculate Monthly and Lumpsum
            //================================================
            let goalAccYearApi = this.accmpYear;
            this.showMontlyLumpsum(goalAccYearApi, 0, goalTypeApi);
        	}else{
            if(resData.error == undefined){
              this.showErrorText = "Page session expired, Please refresh the page";
              this.showError = true;
            }else{
              this.showErrorText = resData.error;
              this.showError = true;
            }
        	}
        }).catch(response => {
		        console.log(response.data);
		    })
  		}
  	}, 
    showCostDelay(){
      // console.log("Cost of delay triggered");
      // console.log((this.noOfYear - this.value));
      axios.post('/csdCalcFV',{sipInvst: this.recomdSIP, noOfMonths: ((this.noOfYear - this.value)*12), _token: this.$token})
      .then((result)=>{
        // console.log(result);
        let fvData = result.data;
        if(fvData.status == 1){
          let fvResultApi = JSON.parse(fvData.result);
          let futureValue = fvResultApi.futureValue;

          //show Corpus differnece to the user 
          //=====================================
          let targetDiff = this.netCorpForCalc - futureValue;
          this.csdtargetDiffHtml = this.shorthandCurrency(targetDiff, true);
          this.showAmtDiff = true;  
          // console.log("netCorpForCalc="+this.netCorpForCalc);
          // console.log("futureValue="+futureValue);
          // console.log("corpDiff="+targetDiff);

        }else{
          this.showErrorText = resData.errcode+"  "+(resData.errmsg ? resData.errmsg : '');
          this.csdshowError = true;
          this.showError = false;
          this.showAmtDiff = false;
        }
      }).catch(result => {
          console.log(result)
      })
    },
    showMontlyLumpsum(goalAccYearApi, costOfDelay, goalTypeApi){
      // console.log("Calculate Monthly and Lumpsum");
      axios.post('/getRecomdInvstValuesWithoutGoal',{goalType: goalTypeApi, netCorpus: this.netCorpForCalc, goalAccYear: goalAccYearApi, _token: this.$token})
      .then((result)=>{
        // console.log(result);
        let resData = result.data;
        if(resData.status == 1){
          let resResult = JSON.parse(resData.result);
          let resResData = resResult.goalRecomdInvstValuesList['0'];

          if(costOfDelay == 0){
            this.recomdSIP = resResData.recomdSIP;
            this.recomdLumpsum = resResData.recomdLumpsum;

            // Amounts are in shorthand L or cr
            //==================================================
            // this.recomdSIPHtml = this.shorthandCurrency(resResData.recomdSIP,true);
            // this.recomdLumpsumHtml = this.shorthandCurrency(resResData.recomdLumpsum, true);

            this.recomdSIPHtml = this.commaSeparateNumber(resResData.recomdSIP,true);
            this.recomdLumpsumHtml = this.commaSeparateNumber(resResData.recomdLumpsum, true);
          }else{
            this.csdrecomdSIP = resResData.recomdSIP;
            // this.csdrecomdLumpsum = resResData.recomdLumpsum;
          }

          //show amount differnce after cost of delay
          //==========================================
          // console.log("costOfDelay"+costOfDelay);
          if(costOfDelay == 1){
            this.showAmtDiff = true;

            //show monthly differnece to the user 
            //=====================================
            let monthlyDiff = this.csdrecomdSIP - this.recomdSIP;
            this.csdMonthlyDiffHtml = this.shorthandCurrency(monthlyDiff, true);
            // console.log("recomdSIP="+this.recomdSIP);
            // console.log("csdrecomdSIP="+this.csdrecomdSIP);
            // console.log("monthlyDiff="+monthlyDiff);
          }else{
            this.showAmtDiff = false;
          }

        }else{
          this.showErrorText = resData.errcode+"  "+(resData.errmsg ? resData.errmsg : '');
          if(costOfDelay == 0){
            this.showError = true;
            this.csdshowError = false;
          }else{
            this.csdshowError = true;
            this.showError = false;
          }
        }
      }).catch(result => {
          console.log(result)
      })
    },
  	resetCalculation(){
      // On keyup of field show button for calculation and hide result 
			//================================================================
			this.showErrorText = "";
    	this.showError = false;
    }
  },
};
</script>

<style lang="scss" scoped></style>
